



















































































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import CompanyKey from "@/components/company-key";
import router from '../../../router';
import DialogDeleteJob from './DialogDeleteJob.vue'

export default createComponent({
  setup(props,context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }

    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
  
    onMounted(async() => {
      displayui.closeDialogRecruitmentError()
    });
    const deleteJob = companyRecruitment.deleteJob
    const jobSearchInfor = computed(() => companyRecruitment.jobSearchInfor);
    const dialog = computed(() => displayui.dialogDeleteJob);
    const openDialog = computed(() => displayui.openDeleteJobDialog);
    const closeDialog = computed(() => displayui.closeDeleteJobDialog);
    const deleteJobDetail =  async(selected:any) => {
      await companyRecruitment.deleteJob(selected)
      await companyRecruitment.searchJob('','','','')
    }
    const handleDisableCheckbox = (item: {common_id: any}, items: any) => {
      let duplicatedId = companyRecruitment.jobSearchInfor.values.filter((it : {common_id: any}) => it.common_id == item.common_id )
      let check= false
      duplicatedId.map((it: {recruitment : any, canceled: any, rejected: any, public_flg: any}) => {
        if(it.recruitment > 0 || it.canceled > 0 || it.rejected > 0 || it.public_flg == -1){
          check = true
        }
      })
      return check
    }

    const handleData = (items: any) => {
        let filter = items.filter((item: any) => {
        let duplicatedId = companyRecruitment.jobSearchInfor.values.filter((it : {common_id: any}) => it.common_id == item.common_id )
        let check = true
        duplicatedId.map((it: {recruitment : any}) => {
          if(it.recruitment > 0){
            check = false
          }
        })
        return check
      })
      if(filter.length > 0){
        companyRecruitment.setCheckAllButtonTrue()
      }else {
        companyRecruitment.setCheckAllButtonFalse()
      }
      return true
    }
    const toJobCreate = () => {
      router.push('/company_offer/detail')
    }
    const toJobSaveDraft = () => {
      router.push('/company_offer/draft')
    }
    const toJobDetail = (commonId: any, recruitment: any, work_start_date: any) => {
      router.push(`/company_offer/job_information/${commonId}/recruitment/${recruitment}/work_start_date/${work_start_date.replace(/\//g, '_')}`)
    }
    const companyInfor = computed(() => company.companyInformation.companyInforList) as any;
    const stateDeleteJob = computed(() =>  companyRecruitment.stateDeleteJob)
    const firstPage = 1
    const checkAllButton = computed(() => companyRecruitment.checkAllButton)
    return {
      firstPage,
      jobSearchInfor,
      dialog,
      openDialog,
      closeDialog,
      deleteJob,
      deleteJobDetail,
      toJobCreate,
      toJobSaveDraft,
      toJobDetail,
      companyInfor,
      stateDeleteJob,
      handleDisableCheckbox,
      handleData,
      checkAllButton
    };
  },
  components: {
    DialogDeleteJob
  }
})
